import React from 'react';
import { Select, SelectProps } from '../Select/Select';
import { CustomLabel } from '../Select/Select.styles';

interface FormSelectProps extends SelectProps {
  label?: string;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  label,
  id,
  ...selectProps
}) => {
  return (
    <div>
      {label && <CustomLabel htmlFor={id}>{label}</CustomLabel>}
      <Select id={id} {...selectProps} />
    </div>
  );
};

export default FormSelect;
